const CookingSettingCreatePage = () => {
	return <div>Hello</div>;
};

export default CookingSettingCreatePage;
